import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { StatusService } from '../../../service/api/status-service';
import { redux } from 'Core/redux';

export const STORE_KEY = 'status';
export const INITIAL_STATE = {
  data: [],
  loading: false,
  error: null,
  processdata: [],
  processloading: false,
  processerror: null,
};

export const fetchStatuses = createAsyncThunk('status/fetchStatuses', async () => {
  const { response } = await StatusService.getAllStatuses();
  return response;
});

export const fetchAllProcessStatuses = createAsyncThunk('status/fetchAllProcessStatuses', async () => {
  const { response } = await StatusService.getAllProcessStatuses();
  return response;
});

export const { reducer, actions } = createSlice({
  name: STORE_KEY,
  initialState: INITIAL_STATE,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchStatuses.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchStatuses.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchStatuses.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(fetchAllProcessStatuses.pending, state => {
        state.processloading = true;
        state.processerror = null;
      })
      .addCase(fetchAllProcessStatuses.fulfilled, (state, action) => {
        state.processloading = false;
        state.processdata = action.payload;
      })
      .addCase(fetchAllProcessStatuses.rejected, (state, action) => {
        state.processloading = false;
        state.processerror = action.error.message;
      });
  },
});

redux.injectReducer(STORE_KEY, reducer);
